import { useDraggable } from '@dnd-kit/core';

const DraggableDriverCard = ({ driver, children }) => {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `driver-${driver.id}`,

    data: {
      driver,
    },

    activationConstraint: {
      distance: 8,
    },
  });
  const style = {
    opacity: isDragging ? 0 : 1,
    cursor: 'grab',
    touchAction: 'none',
  };

  return (
    <div ref={setNodeRef} style={style} {...listeners} {...attributes}>
      {children}
    </div>
  );
};

export default DraggableDriverCard;
